import { Action, createReducer, on } from "@ngrx/store";
import { AppState } from "./app.state";
import {retrieveValueConfPagesList, ValueConfPageTypes} from './value-conf-page.actions';
import * as storage from '../storage';

export const initialValueConfPageState: AppState = {
    valueconfpages: storage.getItem('valueconfpages').valueconfpages
}

// const _valueConfPageReducer = createReducer(initialValueConfPageState, on(retrieveValueConfPagesList, (state, action) => {
//     return{
//         ...state,
//         valueconfpages: action.valueconfpages
//     }
// }));

const _valueConfPageReducer = createReducer(initialValueConfPageState, on(retrieveValueConfPagesList, (state, action) => ({...state, valueconfpages: action.valueconfpages})));

export function valueConfPageReducer(state:AppState | undefined, action:Action) : any {
    // switch(action.type){
    //     case ValueConfPageTypes.RetrieveValueConfPagesListType: return _valueConfPageReducer(state, action);
    //     default: return state;
    // }
    return _valueConfPageReducer(state, action);
}

export const getValueConfPages = (state: AppState) => {
    console.log('############state.valueconfpages#############')
    console.log(state.valueconfpages)
    console.log('#########################')
    return state.valueconfpages;
}